/* tslint:disable */
/* eslint-disable */
export enum Layout {
  Default = 'DEFAULT',
  Fresh = 'FRESH'
}
